/*
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:52:48
 * @LastEditTime: 2021-06-05 09:56:01
 * @LastEditors: 卢靖康
 */
import axios from "../axios";

export default {
  getBannerList(inOpts) {
    return axios.request({
      cmd: "bannerapi/indexBannerList",
      data: inOpts,
    });
  },
  getPageData(inOpts) {
    return axios.request({
      cmd: "",
      data: inOpts,
    });
  },
  getFooterData(data) {
    return axios.request({
      cmd: "follow/us",
      data,
    });
  },
};
